import {FC} from 'react'
import {useLocation} from 'react-router-dom'
import {getHelpUrlForPath} from './helpLinks'

// Botão "?" ao lado do título da página: abre o post da Central de ajuda daquela tela.
export const PageHelpLink: FC = () => {
  const {pathname} = useLocation()
  const url = getHelpUrlForPath(pathname)

  if (!url) return null

  return (
    <a
      href={url}
      target='_blank'
      rel='noreferrer'
      className='page-help-link'
      title='Ajuda desta tela'
      aria-label='Ajuda desta tela (abre a Central de ajuda)'
    >
      <i className='bi bi-question-circle'></i>
    </a>
  )
}
